module.exports = __webpack_public_path__ + "static/media/tutorial-timeline-banner.12d978c1.svg";